/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Occupation_HeavyInputs */

const en_us2_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heavy physical work`)
};

const pt_br2_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho físico pesado`)
};

const es_419_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajo físico pesado`)
};

const pt_pt2_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabalho físico pesado`)
};

const fr_fr2_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Travail physique intense`)
};

const de_de2_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwere körperliche Arbeit`)
};

const it_it2_occupation_heavy = /** @type {(inputs: Occupation_HeavyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavoro fisico pesante`)
};

/**
* | output |
* | --- |
* | "Heavy physical work" |
*
* @param {Occupation_HeavyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const occupation_heavy = /** @type {((inputs?: Occupation_HeavyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Occupation_HeavyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_occupation_heavy(inputs)
	if (locale === "es-419") return es_419_occupation_heavy(inputs)
	if (locale === "pt-PT") return pt_pt2_occupation_heavy(inputs)
	if (locale === "fr-FR") return fr_fr2_occupation_heavy(inputs)
	if (locale === "de-DE") return de_de2_occupation_heavy(inputs)
	if (locale === "it-IT") return it_it2_occupation_heavy(inputs)
	return en_us2_occupation_heavy(inputs)
});
export { occupation_heavy as "occupation.heavy" }